<template>
    <div class="about">
      <TTable />
    </div>
  </template>
  <script>
  import TTable from "../components/Time-Table.vue";
    export default{
        components: {
            TTable,
        },
    }
</script>
  